import { Answer } from '@/models/configurator/answer';
import { AnswerService } from '@/services/configurator/answer';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

export interface ICreateAnswerPayload {
  answer: Answer;
  snapshot?: number;
}

export type AnswerState = typeof state;

const answerService = new AnswerService();

export const state = {
  answers: [] as Answer[]
};

export const mutations: MutationTree<AnswerState> = {
  ADD_ANSWER(state, payload: Answer) {
    state.answers.push(payload);
  },

  SET_ANSWERS(state, payload: Answer[]) {
    state.answers = payload;
  },

  UPDATE_ANSWER(state, payload: Answer) {
    const index = state.answers.findIndex(answer => answer.id === payload.id);
    state.answers.splice(index, 1, payload);
  },

  REMOVE_ANSWER(state, payload: number) {
    const index = state.answers.findIndex(answer => answer.id === payload);
    state.answers.splice(index, 1);
  }
};

export const actions: ActionTree<AnswerState, AnswerState> = {
  createAnswer: async ({ commit, state }, payload: ICreateAnswerPayload) =>
    await new Promise((resolve, reject) => {
      answerService
        .createAnswer(payload.answer, payload.snapshot)
        .then(answer => {
          const index = state.answers.findIndex(s => s.id === answer.id);
          if (index === -1) {
            commit('ADD_ANSWER', answer);
          } else {
            commit('UPDATE_ANSWER', answer);
          }
          resolve(answer);
        })
        .catch(err => {
          reject(err);
        });
    }),

  fetchAnswers: ({ commit }, configurationId: number) =>
    answerService.fetchAnswers(configurationId).then(answers => {
      commit('SET_ANSWERS', answers);
      return answers;
    }),

  fetchAnswer: (
    { commit, state },
    { configurationId, id }: { configurationId: number; id: number }
  ) =>
    new Promise((resolve, reject) => {
      answerService
        .fetchAnswer(configurationId, id)
        .then(answer => {
          const index = state.answers.findIndex(s => s.id === answer.id);
          if (index === -1) {
            commit('ADD_ANSWER', answer);
          } else {
            commit('UPDATE_ANSWER', answer);
          }
          resolve(answer);
        })
        .catch(err => {
          reject(err);
        });
    }),

  updateAnswer: (
    { commit, state },
    { configurationId, answer }: { configurationId: number; answer: Answer }
  ) =>
    new Promise((resolve, reject) => {
      answerService
        .updateAnswer(configurationId, answer)
        .then(answer => {
          const index = state.answers.findIndex(s => s.id === answer.id);
          if (index === -1) {
            commit('ADD_ANSWER', answer);
          } else {
            commit('UPDATE_ANSWER', answer);
          }
          resolve(answer);
        })
        .catch(err => {
          reject(err);
        });
    }),

  deleteAnswer: (
    { commit },
    { configurationId, id }: { configurationId: number; id: number }
  ) =>
    answerService.deleteAnswer(configurationId, id).then(() => {
      commit('REMOVE_ANSWER', id);
    })
};

export const getters: GetterTree<AnswerState, AnswerState> = {
  getAnswerById: state => (id: number) => {
    return state.answers.find((answer: any) => answer.id === id);
  }
};
